import React, { useRef } from 'react';
import { SelectStateService } from './state/select-state.service';
import { SmartSelectOptions } from './types';

const StateContext = React.createContext<SelectStateService | undefined>(undefined);
const OptionsContext = React.createContext<SmartSelectOptions | undefined>(undefined);

export const useSelectState = (): SelectStateService => {
  const ctx = React.useContext(StateContext);

  if (!ctx) {
    throw new Error('useSelectState must be used within a SmartSelectProvider');
  }

  return ctx;
};
export const useSelectOptions = (): SmartSelectOptions => {
  const ctx = React.useContext(OptionsContext);

  if (!ctx) {
    throw new Error('useSelectOptions must be used within a SmartSelectProvider');
  }

  return ctx;
};

export const SmartSelectProvider: React.FC<React.PropsWithChildren<{ options: SmartSelectOptions }>> = ({
  options,
  children,
}) => {
  const ref = useRef<SelectStateService>(new SelectStateService());

  return (
    <StateContext.Provider value={ref.current}>
      <OptionsContext.Provider value={options}>{children}</OptionsContext.Provider>
    </StateContext.Provider>
  );
};
